import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Body1, HeaderBlock } from '@fs/zion-ui'
import { Title } from '@fs/zion-head'
import PersonPageBanner from '@fs/tree-person-page-banner'
import PersonNotFound from './PersonNotFound.svg'

const imageCss = css`
  background-image: url(${PersonNotFound});
  background-color: #c4c4c4;
  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100vh;
`
const errorCss = css`
  text-align: center;
  margin-top: 50px;
`

const person = {
  name: undefined,
  gender: 'UNKNOWN',
}

export default function NotFoundError(): JSX.Element {
  const [t] = useTranslation()

  return (
    <div css={imageCss}>
      <Title>{`${t('ancestors.page.tab.title', 'Ancestors in Family Tree')} | ${t(
        'ancestors.not-found-error.header',
        'Well, this is unexpected...'
      )}`}</Title>
      <PersonPageBanner person={person} notFound />
      <div data-testid="not-found-error" css={errorCss}>
        <HeaderBlock heading={t('ancestors.not-found-error.header', 'Well, this is unexpected...')} size="md" />
        <Body1>
          {t(
            'ancestors.not-found-error.text',
            'Unfortunately, we are unable to find the requested content. Please try your search again, or come back later.'
          )}
        </Body1>
      </div>
    </div>
  )
}
